const theme = {
  colors: {
    primary: '#1D3557',
    orange: '#FF6A00',
    primaryHovered: '#2C4A72',
    primaryPressed: '#1C2F49',
    secondaryPressed: '',
    secondaryHovered: '',
    outlined: '#C8C8C8',
    white: '#FFFFFF',
    secondary: '#2D6CDF',
    background: '#F8F8F8',
    text: '#333',
    success: '#15C7A7',
    danger: '#E63946',
    warning: '#ffc107',
    info: '#17a2b8',
    light: '#f8f9fa',
    dark: '#343a40',
    primaryText: '#212529',
    secondaryText: '#6C757D',
    borderColor: '#D4D8DD',
    warningColor: '#F4A261',
    tagGeneralColor: '#4461E6',
    tagHrColor: '#F63DB7',
    approveTextColor: '#15C7A7',
    tagLegalColor: '#2ECC71',
    tagPendingColor: '#FAA11C',
    emptyTitleColor: '#212529',
    activeBackground: '#dfffe2',
    inactiveBackground: '#ffedea',
    activeTextColor: '#00c853',
    lifespanSingle: '#F63DB7',
    lifespanReusable: '#2D6CDF',

    inactiveTextColor: '#ff5252',
    inPendingTextColor: '#FAA11C',
    inPendingBackgroundColor: '#FEF5E8',
    inDisableTextColor: '#6C757D',
    inDisableBackgroundColor: '#F0F1F2',
    roleTagBackground: '#ffefea',
    roleTagTextColor: '#ff8a65',
    UnavailableColor: '#E63946',
    UnavailableBackgroundColor: '#E63946',
    AvailableColor: '#15C7A7',
    AvailableBackgroundColor: '#15C7A7',
    teamLeadTextColor: '#5c5f62',
    avatarBackground: '#e0e0e0',
    lightGray: '#e9ecef',
    hoverText: '#2D6CDF',
    mutedGray: '#adb5bd',
    hoverHighlight: '#e7f0ff',
    memberColor: '#2a2a2a',
    low: '#F2D117',
    normal: '#2D6CDF',
    high: '#15C7A7',
    urgent: '#E63946',
    toDo: '#2a2a2a',
    inProgress: '#2a2a2a',
    waiting: '#2a2a2a',
    resolved: '#2a2a2a',
    closed: '#2a2a2a',
    todoBackground: '#BDBDBD',
    todoColor: '#FFFFFF',
    inProgressBackground: '#2D6CDF',
    usageServiceUse: '#9747FF',
    usageServiceBackground: '#9747FF',
    RejectedBackground: '#E63946',
    ReopenBackground: '#7367F0',
    inProgressColor: '#FFFFFF',
    resolvedBackground: '#27AE60',
    resolvedColor: '#FFFFFF',
    closedBackground: '#4F4F4F',
    closedColor: '#FFFFFF',
    closedColorForStatus: '#6f6f6f',
    waitingBackground: '#F4A261',
    waitingColor: '#FFFFFF',
    TaskColor: '#2D6CDF',
    BugColor: '#E63946',
    SuggestionColor: '#F63DB7',
    ApprovedColor: '#15C7A7',
    modifiedBackground: '#9747FF',
    modifiedColor: '#9747FF',
    FeatureColor: '#15C7A7',
    SupportColor: '#FF6A00',
    todoTicketCard: '#F0F0F0',
    inProgressTicketCard: '#F4FAFF',
    waitingTicketCard: '#FFF9F4',
    resolvedTicketCard: '#F8FFFB',
    closedTicketCard: '#F5F5F5',
    rejectedTicketCard: '#FFF6F7',
    reopenTicketCard: '#F7F3FB',
    featureTicketCard: '#9747FF',
  },

  widths: {
    full: '100%',
    half: '50%',
    third: '33.33%',
    quarter: '25%',
    authForm: '390px',
  },

  heights: {
    full: '100vh',
    half: '50%',
  },

  fonts: {
    main: '"Nunito", sans-serif',
    secondary: '"Nunito", sans-serif',
  },

  fontWeights: {
    normal: 400,
    bold: 700,
    bolder: 900,
  },

  fontSizes: {
    small: '12px',
    medium: '16px',
    large: '20px',
    xLarge: '24px',
  },

  spacing: {
    small: '4px',
    medium: '8px',
    large: '20px',
    xLarge: '32px',
  },

  borders: {
    radius: '8px',
    width: '1px',
    style: 'solid',
    color: '#ccc',
  },

  shadows: {
    small: '0 1px 2px rgba(0, 0, 0, 0.1)',
    medium: '0px 0px 15px 0px #00000012',
    large: '0 4px 8px rgba(0, 0, 0, 0.1)',
  },

  zIndex: {
    modal: 1000,
    tooltip: 2000,
    overlay: 3000,
  },

  borderRadius: {
    small: '5px',
    medium: '8px',
    large: '16px',
  },

  paddings: {
    container: '5px',
    pageTop: '30px',
  },

  margins: {
    marginTopSmall: '14px',
    pageTop: '30px',
    pageBottom: '54px',
  },

  breakpoints: {
    xs: '320px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
  },

  typography: {
    fontFamily: {},
    fontSize: {
      small: '12px',
      formDesc: '13px',
      medium: '16px',
      large: '24px',
    },
    fontWeight: {
      light: 300,
      regular: 400,
      medium: 500,
      semiBold: 600,
      bold: 700,
      extraBold: 800,
    },
    lineHeight: {
      extraSmall: '13px',
      small: '15px',
      medium: '19px',
      large: '22px',
      extraLarge: '30px',
    },
  },
};

export default theme;
